import { Policy } from 'cockatiel';

// Create a retry policy that'll try whatever function we execute 3
// times with an exponential backoff.
const exponentialBackoffThreeTimesPolicy = Policy.handleAll()
  .retry()
  .attempts(3)
  .exponential();

export const exponentialBackoffThreeTimes = cb => exponentialBackoffThreeTimesPolicy.execute(cb);
